import React from "react";


export type AppContextType = {
    input: string|Blob,
    setInput: React.Dispatch<React.SetStateAction<string|Blob>>,

    openAIApiKey: string|undefined,
    setOpenAIApiKey: React.Dispatch<React.SetStateAction<string|undefined>>,
    assemblyAIApiKey: string|undefined
    setAssemblyAIApiKey: React.Dispatch<React.SetStateAction<string|undefined>>,
}
export const AppContext = React.createContext( {} as AppContextType );